export default ({email, password}) => {
  const error = {}
  if (!email) {
    error.email = 'email'
  } else {
    if (email && email.trim() === '') { error.email = 'email' } else {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (email !== 'admin' && !pattern.test(email)) {
        error.email = 'invalidEmail'
      }
    }
  }
  if (!password) {
    error.password = 'password'
  } else {
    if (password && password === '') { error.password = 'password' }
  }
  return error
}
